import SelectWithLoader from '../../common/SelectWithLoader'
import { HugeiconsIcon } from '@hugeicons/react'
import { TextNumberSignIcon, TextSquareIcon, Dollar01Icon, Calendar04Icon, ArrowDown01Icon } from '@hugeicons/core-free-icons'
import { ADDITIONAL_INFO_DEFAULT_INPUT } from '../../../constants'

export const FieldTypeOptions = [
  { id: '', showIcon: false, label: 'Date', type: 'date', value: 'date', icon: <HugeiconsIcon icon={Calendar04Icon} size={12} />, input: ADDITIONAL_INFO_DEFAULT_INPUT.date },
  { id: '', showIcon: false, label: 'Currency', type: 'currency', value: 'currency', icon: <HugeiconsIcon icon={Dollar01Icon} size={12} />, input: ADDITIONAL_INFO_DEFAULT_INPUT.currency },
  { id: '', showIcon: false, label: 'Number', type: 'number', value: 'number', icon: <HugeiconsIcon icon={TextNumberSignIcon} size={12} />, input: ADDITIONAL_INFO_DEFAULT_INPUT.number },
  { id: '', showIcon: false, label: 'Text', type: 'text', value: 'text', icon: <HugeiconsIcon icon={TextSquareIcon} size={12} />, input: ADDITIONAL_INFO_DEFAULT_INPUT.text },
]

const compactStyle = {
  container: (base) => ({
    ...base
  }),
  control: (base, state) => ({
    ...base,
    width: '90px',
    minHeight: '30px',
    borderRadius: '6px',
    backgroundColor: 'transparent',
    border: 'None',
    cursor: 'pointer'
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: '10px'
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0px',
    fontSize: '10px',
    height: '30px',
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: '4px',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '4px',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '10px'
  }),
  singleValue: (provided) => ({
    ...provided,
    marginBottom: '4px',
    fontSize: '10px'
  }),
}

export const FieldTypeSelect = ({ field, setField, isDisabled = undefined }) => {
  return (
    <SelectWithLoader
      dropdownIndicator={<HugeiconsIcon icon={ArrowDown01Icon} size={10} />}
      isDisabled={isDisabled}
      options={FieldTypeOptions}
      value={field}
      styles={compactStyle}
      showIndicatorSeparator={false}
      onChange={(selectedOption) => {
        setField(selectedOption)
      }}
    />
  )
}
